"use client";

import { ArrowRight, Check, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Shop() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const {
    ref: subRef,
    isVisible: subVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: previewRef,
    isVisible: previewVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const cartItems = [{
    name: "Central Telefónica 3CX",
    desc: "Licencia anual estándar",
    price: "$199.00"
  }, {
    name: "Soporte Técnico Premium",
    desc: "12 meses de asistencia",
    price: "$49.00"
  }, {
    name: "Configuración SBC",
    desc: "Implementación inicial",
    price: "$29.00"
  }];
  return;
}